import { render, staticRenderFns } from "./sfc-logo-desktop-black.vue?vue&type=template&id=17cc80ca&scoped=true&lang=pug&"
import script from "./sfc-logo-desktop-black.vue?vue&type=script&lang=js&"
export * from "./sfc-logo-desktop-black.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cc80ca",
  null
  
)

export default component.exports